import React, { useContext } from 'react';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import EUserTypes from '../../enums/EUserTypes';
import InternalLayout from './InternalLayout';
import OperatorLayout from './OperatorLayout';
import { useWakeLock } from '../../hooks/useWakeLock';

/**
 * Escolhe o layout conforme o papel do usuário logado.
 *
 * - Operador / Operador-comprador → OperatorLayout (PWA mobile-first, sem menu lateral).
 * - Demais papéis (Admin do painel) → InternalLayout (menu lateral/gaveta atual).
 *
 * Centraliza a decisão em um único ponto para o Router não precisar conhecer papéis.
 *
 * O useWakeLock mantém a tela acesa (impede o modo descanso) enquanto a sessão
 * está ativa — útil no PWA em celular/tablet para o operador não precisar ficar
 * destravando o aparelho a cada registro. Em sem suporte, falha silenciosamente.
 */
const AppLayout = () => {
  const { loggedUser } = useContext(GeneralContext);
  useWakeLock();

  const isOperator =
    loggedUser?.type === EUserTypes.OPERADOR.code ||
    loggedUser?.type === EUserTypes.OPERADOR_COMPRADOR.code ||
    loggedUser?.type === EUserTypes.LIDER.code;

  return isOperator ? <OperatorLayout /> : <InternalLayout />;
};

export default AppLayout;
